import { formatDistanceToNow } from 'date-fns';
import vi from 'date-fns/locale/vi';

export const formatDistanceToNowVi = (value: Date | number) => {
  return formatDistanceToNow(value, { locale: vi });
};
